document.addEventListener("DOMContentLoaded", function () {
  addQuickActionsMobile();
  document.addEventListener("facet:rendered", function (event) {
    addQuickActionsMobile();
  });
});

function addQuickActionsMobile() {
  // Seleccionamos ambos contenedores
  document
    .querySelectorAll(
      "ul#product-grid, .ru-featured-collection ul.contains-card, .related-products-ru, .main-search-RU ul.product-grid ",
    )
    .forEach((productGrid) => {
      productGrid.addEventListener("click", function (event) {
        // Lógica para Quick View
        if (event.target.closest(".quickview-mobile")) {
          handleQuickView(event);
        }

        // Lógica para Quick Add
        if (event.target.closest(".wim-quickadd")) {
          handleQuickAdd(event);
        }
      });
    });
}

// Función para manejar el evento de Quick View
function handleQuickView(event) {
  const liElement = event.target.closest("li");
  const productOptions = liElement.querySelector(
    ".quick-add.quick-add__custom",
  );
  if (!productOptions) return;

  productOptions.classList.add("wim-quickview");

  const wimPopup = document.createElement("div");
  wimPopup.classList.add("wim-popup");
  setTimeout(() => {
    wimPopup.classList.add("wim-popup-enter");
  }, 50);

  const overlay = document.createElement("div");
  overlay.classList.add("wim-popup-overlay");

  const wimPopupContent = document.createElement("div");
  wimPopupContent.classList.add("wim-popup-content");

  // --- Sección de colores ---
  const cardWrapper =
    liElement.querySelector(".WIM-product-card-wrapper") || liElement;
  const colorsWrapper = cardWrapper.querySelector(".WIM-group-colors-wrapper");
  if (colorsWrapper) {
    const colorTitle = document.createElement("p");
    colorTitle.classList.add("wim-popup-colors-title");
    colorTitle.textContent =
      (window.wimPopupStrings && window.wimPopupStrings.selectColor) || "";
    wimPopupContent.appendChild(colorTitle);
    wimPopupContent.appendChild(buildPopupColors(colorsWrapper));
  }

  // --- Formulario de variantes ---
  // Intentamos construir el formulario desde el JSON de variantes del card
  // para evitar conflictos con product-info/variant-radios/product-form custom elements
  const productInfoEl = productOptions.querySelector("product-info");
  const variantsScriptEl = productOptions.querySelector(
    'script[type="application/json"]',
  );
  const productId = productInfoEl ? productInfoEl.dataset.section : null;
  const productUrl =
    (productInfoEl ? productInfoEl.dataset.url : null) ||
    (productOptions.querySelector("[data-url]") &&
      productOptions.querySelector("[data-url]").dataset.url) ||
    (liElement.querySelector("a.card__inner") &&
      liElement.querySelector("a.card__inner").getAttribute("href")) ||
    "#";

  var formBuiltFromJson = false;
  if (variantsScriptEl && productId) {
    try {
      var variants = JSON.parse(variantsScriptEl.textContent);
      var options = [];
      productOptions
        .querySelectorAll("fieldset legend.form__label")
        .forEach(function (legend) {
          options.push({ name: legend.textContent.trim() });
        });
      var initialProduct = {
        id: productId,
        url: productUrl,
        variants: variants,
        options: options,
      };
      // Placeholder que rebuildPopupQuickAdd reemplazará
      var placeholder = document.createElement("div");
      placeholder.classList.add("quick-add", "quick-add__custom", "no-js-hidden");
      wimPopupContent.appendChild(placeholder);
      rebuildPopupQuickAdd(wimPopupContent, initialProduct);
      formBuiltFromJson = true;
    } catch (e) {
      console.warn("wim-popup: fallback al clon", e);
    }
  }

  if (!formBuiltFromJson) {
    // Fallback: clonar el formulario original
    var clonedProductOptions = productOptions.cloneNode(true);
    clonedProductOptions
      .querySelectorAll("legend.form__label")
      .forEach(function (legend) {
        legend.textContent = getPopupLegendText(legend.textContent.trim());
      });
    wimPopupContent.appendChild(clonedProductOptions);
  }

  // --- Botón de cierre y enlace de detalles ---
  const closeButton = createCloseButton();
  wimPopupContent.appendChild(closeButton);
  wimPopupContent.appendChild(createDetailsLink(productUrl));

  // --- Montar el popup en el DOM ---
  wimPopup.appendChild(overlay);
  wimPopup.appendChild(wimPopupContent);
  document.body.appendChild(wimPopup);
  document.body.classList.add("wim-popup-open");

  closeButton.addEventListener("click", function () {
    closePopup(wimPopup);
  });
  overlay.addEventListener("click", function () {
    closePopup(wimPopup);
  });

  if (colorsWrapper) {
    initPopupColorSwatches(wimPopupContent);
  }

  // Solo usar handleInputSelection si el JSON no estaba disponible (fallback)
  if (!formBuiltFromJson) {
    handleInputSelection(wimPopupContent, productOptions);
  }
}

// Función para manejar el evento de Quick Add
function handleQuickAdd(event) {
  const liElement = event.target.closest("li");
  const submitButton = liElement.querySelector("button.quick-add__submit");

  if (submitButton) {
    submitButton.click();
  }
}

// Función para crear el enlace de detalles del producto
function createDetailsLink(url) {
  var link = document.createElement("a");
  link.classList.add("wim-popup-details");
  link.href = url || "#";
  link.textContent =
    (window.wimPopupStrings && window.wimPopupStrings.viewDetails) || "";
  return link;
}

// Función para crear el botón de cierre
function createCloseButton() {
  const closeButton = document.createElement("div");
  closeButton.classList.add("wim-popup-close");
  closeButton.innerHTML = `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="close_small">
            <mask id="mask0_1_287" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
                <rect id="Bounding box" width="32" height="32" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_1_287)">
                <path id="close_small_2" d="M10.7383 22.2307L9.76929 21.2617L15.0306 16L9.76929 10.7717L10.7383 9.80267L16 15.064L21.2283 9.80267L22.1973 10.7717L16.936 16L22.1973 21.2617L21.2283 22.2307L16 16.9693L10.7383 22.2307Z" fill="black"/>
            </g>
        </g>
    </svg>
  `;
  return closeButton;
}

// Función para cerrar el popup
function closePopup(wimPopup) {
  wimPopup.classList.remove("wim-popup-enter");
  wimPopup.classList.add("wim-popup-leave");

  setTimeout(() => {
    document.body.classList.remove("wim-popup-open");
    wimPopup.remove();
  }, 500);
}

// Devuelve el texto descriptivo del legend según el nombre de la opción
function getPopupLegendText(optionName) {
  var lower = (optionName || "").toLowerCase().trim();
  if (lower === "tamaño" || lower === "talla" || lower === "size") {
    return (window.wimPopupStrings && window.wimPopupStrings.selectSize) || optionName;
  }
  if (lower === "color" || lower === "colour") {
    return (window.wimPopupStrings && window.wimPopupStrings.selectColorOption) || optionName;
  }
  return optionName || "";
}

// Construye el wrapper de colores del popup con todos los colores (sin límite)
function buildPopupColors(colorsWrapper) {
  var scriptTag = colorsWrapper.querySelector(".wim-colors-json");
  var selectedEl = colorsWrapper.querySelector(".link--selected");
  var selectedHandle = selectedEl ? selectedEl.dataset.productHandle : null;

  if (!scriptTag) {
    var cloned = colorsWrapper.cloneNode(true);
    cloned.classList.add("wim-popup-colors");
    return cloned;
  }

  var allColors;
  try {
    allColors = JSON.parse(scriptTag.textContent);
  } catch (e) {
    var cloned = colorsWrapper.cloneNode(true);
    cloned.classList.add("wim-popup-colors");
    return cloned;
  }

  if (!selectedHandle && allColors.length > 0) {
    selectedHandle = allColors[0].handle;
  }

  var wrapper = document.createElement("div");
  wrapper.classList.add("WIM-group-colors-wrapper", "wim-popup-colors");

  allColors.forEach(function (color) {
    var isSelected = color.handle === selectedHandle;

    var item = document.createElement("div");
    item.classList.add("WIM-group-colors_item");

    var link = document.createElement(isSelected ? "div" : "a");
    link.classList.add("WIM-link-color");
    if (isSelected) link.classList.add("link--selected");
    link.title = color.title;
    link.dataset.productHandle = color.handle;
    link.dataset.productUrl = color.url;
    link.dataset.discount = String(color.discount);
    if (!isSelected) link.href = color.url;

    var media = document.createElement("div");
    media.classList.add("WIM-link-color_media");

    var mediaInner = document.createElement("div");
    mediaInner.classList.add("WIM-media", "media--square");

    var img = document.createElement("img");
    img.src = color.image;
    img.alt = color.title;
    img.loading = "lazy";
    img.width = 100;
    img.height = 100;

    mediaInner.appendChild(img);
    media.appendChild(mediaInner);
    link.appendChild(media);
    item.appendChild(link);
    wrapper.appendChild(item);
  });

  return wrapper;
}

// Función para inicializar el intercambio de colores dentro del popup
function initPopupColorSwatches(wimPopupContent) {
  var colorsWrapper = wimPopupContent.querySelector(".wim-popup-colors");
  if (!colorsWrapper) return;

  colorsWrapper.addEventListener("click", function (e) {
    var colorLink = e.target.closest(".WIM-link-color");
    if (!colorLink) return;
    if (colorLink.classList.contains("WIM-link-color--more")) return;
    if (colorLink.classList.contains("link--selected")) return;

    e.preventDefault();
    e.stopPropagation();

    var handle = colorLink.dataset.productHandle;
    if (!handle) return;

    var prev = colorsWrapper.querySelector(".link--selected");
    if (prev) prev.classList.remove("link--selected");
    colorLink.classList.add("link--selected");

    fetch("/products/" + handle + ".js")
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        rebuildPopupQuickAdd(wimPopupContent, product);
      })
      .catch(function (err) {
        console.error("Popup color swap error:", err);
      });
  });
}

// Reconstruye las opciones de variante y el formulario del popup para un producto nuevo
function rebuildPopupQuickAdd(wimPopupContent, product) {
  var existingQuickAdd = wimPopupContent.querySelector(
    ".quick-add.quick-add__custom",
  );
  if (!existingQuickAdd) return;

  var variants = product.variants;
  var options = product.options;

  var addText =
    (window.variantStrings && window.variantStrings.addToCart) || "Add to cart";
  var soldOutText =
    (window.variantStrings && window.variantStrings.soldOut) || "Sold out";

  var firstAvailable = null;
  for (var i = 0; i < variants.length; i++) {
    if (variants[i].available) {
      firstAvailable = variants[i];
      break;
    }
  }
  if (!firstAvailable) firstAvailable = variants[0];

  var isDefault =
    variants.length === 1 && variants[0].title === "Default Title";
  var productFormId = "wim-popup-form-" + product.id;

  var variantsHtml = "";
  if (!isDefault) {
    for (var oi = 0; oi < options.length; oi++) {
      var opt = options[oi];
      var optName = typeof opt === "object" && opt !== null ? opt.name : opt;
      var pos = oi + 1;
      var key = "option" + pos;

      var seen = {};
      var values = [];
      for (var vi = 0; vi < variants.length; vi++) {
        var val = variants[vi][key];
        if (val && !seen[val]) {
          seen[val] = true;
          values.push(val);
        }
      }

      variantsHtml += '<fieldset class="js product-form__input">';
      variantsHtml +=
        '<legend class="form__label hidden">' +
        WIMEscapeHtml(getPopupLegendText(optName)) +
        "</legend>";
      variantsHtml += '<div class="product-form__input--options">';

      for (var vii = 0; vii < values.length; vii++) {
        var v = values[vii];
        var checked = firstAvailable[key] === v;
        var available = false;
        for (var vj = 0; vj < variants.length; vj++) {
          if (variants[vj][key] === v && variants[vj].available) {
            available = true;
            break;
          }
        }
        var inputId = "wim-popup-" + product.id + "-" + pos + "-" + vii;
        variantsHtml +=
          '<input type="radio" id="' +
          inputId +
          '" name="' +
          WIMEscapeHtml(optName) +
          '" value="' +
          WIMEscapeHtml(v) +
          '" form="' +
          productFormId +
          '"';
        if (checked) variantsHtml += " checked";
        if (!available) variantsHtml += ' class="disabled"';
        variantsHtml += ">";
        variantsHtml +=
          '<label for="' + inputId + '">' + WIMEscapeHtml(v) + "</label>";
      }

      variantsHtml += "</div></fieldset>";
    }
  }

  var isAvailable = firstAvailable && firstAvailable.available;
  var submitText = isAvailable ? addText : soldOutText;

  var html = '<div class="quick-add quick-add__custom no-js-hidden">';
  html += '<div class="product__info-container">';
  html += variantsHtml;
  html += '<div class="product-form">';
  html += '<form method="post" action="/cart/add" id="' + productFormId + '"';
  html += ' accept-charset="UTF-8" class="form" enctype="multipart/form-data"';
  html += ' novalidate="novalidate" data-type="add-to-cart-form">';
  html += '<input type="hidden" name="form_type" value="product">';
  html += '<input type="hidden" name="utf8" value="✓">';
  html +=
    '<input type="hidden" name="id" value="' +
    firstAvailable.id +
    '" class="product-variant-id">';
  html +=
    '<button type="submit" name="add"' +
    ' class="product-form__submit button button--full-width button--primary"';
  if (!isAvailable) html += " disabled";
  html += "><span>" + submitText + "</span></button>";
  html += "</form></div></div></div>";

  var tmpDiv = document.createElement("div");
  tmpDiv.innerHTML = html;
  existingQuickAdd.replaceWith(tmpDiv.firstChild);

  initPopupVariantHandlers(wimPopupContent, product, addText, soldOutText);

  var detailsLink = wimPopupContent.querySelector(".wim-popup-details");
  if (detailsLink) detailsLink.href = product.url;
}

// Maneja la selección de variantes y el envío del formulario dentro del popup reconstruido
function initPopupVariantHandlers(
  wimPopupContent,
  product,
  addText,
  soldOutText,
) {
  var quickAdd = wimPopupContent.querySelector(".quick-add.quick-add__custom");
  if (!quickAdd) return;

  var variants = product.variants;

  var labels = quickAdd.querySelectorAll(".product-form__input--options label");

  labels.forEach(function (label) {
    label.addEventListener("click", function () {
      var fieldset = label.closest("fieldset");

      fieldset
        .querySelectorAll('input[type="radio"]')
        .forEach(function (input) {
          input.removeAttribute("checked");
          input.classList.remove("checked-class");
        });

      var labelFor = label.getAttribute("for");
      var input = fieldset.querySelector("#" + CSS.escape(labelFor));
      if (input) {
        input.setAttribute("checked", "checked");
        input.classList.add("checked-class");
      }

      var selectedValues = {};
      quickAdd.querySelectorAll("fieldset").forEach(function (fs, idx) {
        var checked =
          fs.querySelector('input[type="radio"][checked]') ||
          fs.querySelector('input[type="radio"]:checked');
        if (checked) {
          selectedValues["option" + (idx + 1)] = checked.value;
        }
      });

      var matched = null;
      for (var i = 0; i < variants.length; i++) {
        var isMatch = true;
        for (var k in selectedValues) {
          if (variants[i][k] !== selectedValues[k]) {
            isMatch = false;
            break;
          }
        }
        if (isMatch) {
          matched = variants[i];
          break;
        }
      }

      var hiddenInput = quickAdd.querySelector('input[name="id"]');
      var submitBtn = quickAdd.querySelector("button.product-form__submit");

      if (matched) {
        if (hiddenInput) hiddenInput.value = matched.id;
        if (submitBtn) {
          var span = submitBtn.querySelector("span");
          if (matched.available) {
            submitBtn.removeAttribute("disabled");
            if (span) span.textContent = addText;
          } else {
            submitBtn.setAttribute("disabled", "disabled");
            if (span) span.textContent = soldOutText;
          }
        }
      }
    });
  });

  var form = quickAdd.querySelector('form[data-type="add-to-cart-form"]');
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var submitBtn = form.querySelector("button[type='submit']");
      if (submitBtn && submitBtn.disabled) return;
      if (submitBtn) submitBtn.setAttribute("disabled", "disabled");

      var variantId = form.querySelector('input[name="id"]').value;

      fetch((window.Shopify.routes?.root || "/") + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1 }],
        }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          var wimPopup = wimPopupContent.closest(".wim-popup");
          if (wimPopup) closePopup(wimPopup);

          var cartDrawer = document.querySelector("cart-drawer");
          var cartIconBubble = document.getElementById("cart-icon-bubble");
          if (cartDrawer || cartIconBubble) {
            fetch(
              (window.Shopify.routes?.root || "/") +
                "?sections=cart-drawer,cart-icon-bubble",
            )
              .then(function (r) {
                return r.json();
              })
              .then(function (sections) {
                if (cartDrawer && sections["cart-drawer"]) {
                  var parsed = new DOMParser().parseFromString(
                    sections["cart-drawer"],
                    "text/html",
                  );
                  var newDrawer = parsed.querySelector("cart-drawer");
                  if (newDrawer) {
                    cartDrawer.className = newDrawer.className;
                    cartDrawer.innerHTML = newDrawer.innerHTML;
                  }
                }

                if (cartIconBubble && sections["cart-icon-bubble"]) {
                  cartIconBubble.innerHTML = sections["cart-icon-bubble"];
                }
              });
          }
        })
        .catch(function (err) {
          console.error("Add to cart error:", err);
          if (submitBtn) submitBtn.removeAttribute("disabled");
        });
    });
  }
}

// Función para manejar la selección de los inputs
function handleInputSelection(wimPopupContent, productOptions) {
  const optionLabels = wimPopupContent.querySelectorAll(
    ".product-form__input--options label",
  );

  optionLabels.forEach((label) => {
    label.addEventListener("click", function () {
      const labelText = label.childNodes[0].nodeValue.trim();
      const input = wimPopupContent.querySelector(
        `input[type="radio"][value="${labelText}"]`,
      );

      const allInputs = wimPopupContent.querySelectorAll(
        ".product-form__input--options input",
      );
      allInputs.forEach((input) => {
        input.removeAttribute("checked");
        input.classList.remove("checked-class");
      });

      if (input) {
        input.setAttribute("checked", "checked");
        input.classList.add("checked-class");
      }

      setTimeout(() => {
        const submitButton = productOptions.querySelector(
          "button.product-form__submit",
        );

        if (submitButton) {
          const spanLabel = submitButton.querySelector("span");
          const label = spanLabel?.textContent.trim() || "";

          const wimspanButton = wimPopupContent.querySelector(
            "button.product-form__submit",
          );
          const wimSpan = wimspanButton?.querySelector("span");

          if (wimSpan) {
            wimSpan.textContent = label;
          }

          if (submitButton.disabled) {
            wimspanButton.setAttribute("disabled", "disabled");
          } else {
            wimspanButton.removeAttribute("disabled");
          }
        }
      }, 300);
    });
  });
}
